import { AuditFieldChange, AuditRef } from "./types";

export const EMPTY_VALUE = "—";

export const isCollectionChange = (
  change: AuditFieldChange,
): change is { added: AuditRef[]; removed: AuditRef[] } => "added" in change;

const isRef = (value: unknown): value is AuditRef =>
  typeof value === "object" && value !== null && "id" in value && "label" in value;

export const formatRef = (ref: AuditRef): string =>
  ref.label ? `${ref.label} (#${ref.id})` : `#${ref.id}`;

export const formatAuditValue = (value: unknown): string => {
  if (value === null || value === undefined || value === "") return EMPTY_VALUE;
  if (isRef(value)) return formatRef(value);
  if (typeof value === "object") return JSON.stringify(value);
  return String(value);
};

export const ACTION_BADGE_COLORS: Record<string, string> = {
  create: "success",
  update: "warning",
  delete: "danger",
};
